{
  "auth": {
    "organisationChoice": {
      "title": "Choose your organisation",
      "body": "Your email address is registered with more than one organisation. Choose the one to open.",
      "legend": "Organisations",
      "continue": "Continue",
      "required": "Choose an organisation to continue",
      "back": "Use a different account",
      "continuingAs": "Continuing as",
      "expiredTitle": "This sign-in has timed out",
      "expiredBody": "For your security, the organisation must be chosen within a few minutes of your password. Sign in again to continue.",
      "signInAgain": "Sign in again"
    }
  },
  "mfa": {
    "security": {
      "unavailable": "Two-step sign-in is unavailable in this environment."
    }
  }
}
